var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.divClass,on:{"click":function($event){return _vm.deleteFromCart(_vm.id)}}},[_c('img',{staticClass:"delete-icon",attrs:{"src":"/img/icon-bin.svg"}})])}
var staticRenderFns = []

export { render, staticRenderFns }